module.exports = __webpack_public_path__ + "img/aspNetMvc.4f7ba47a.svg";